import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { IAppState } from '../app/app-state';
import { Action, Store } from '@ngrx/store';
import { IWorkplacesState } from './workplaces-state';
import { NormalizeResponse } from '@core/operators/normalize/normalize-response';
import { ossCatchError } from '@core/operators/catch-error.operator';
import { from } from 'rxjs';
import { IAppRouterState } from '../router/router-state';
import { PayrollDataService } from '@core/data/api/payroll/payroll-data.service';
import { ROUTER_NAVIGATION, WORKPLACES_FETCH, WORKPLACES_FETCH_MORE } from '../action-types';
import { WORKPLACE_ENTITY } from '../entity-types';
import { Workplace } from '@core/models/shared/workplace/workplace';
import {
    FetchWorkplacesAction,
    FetchMoreWorkplacesAction,
    SetWorkplacesAction,
    SetWorkplacesFetchingAction,
    SetWorkplacesFetchingMoreAction,
    MergeWorkplacesAction
} from './workplaces-actions';
import { ossNormalize } from '@core/operators/normalize/normalize.operator';
import { mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { getWorkplaceList } from './workplaces-selectors';

@Injectable()
export class WorkplaceEffects {
    constructor(private store$: Store<IWorkplacesState>,
                private actions$: Actions,
                private payrollDataService: PayrollDataService) {

    }

    fetchWorkplaces$ = createEffect(() => 
        this.actions$.pipe(
            ofType<FetchWorkplacesAction>(WORKPLACES_FETCH),
            switchMap(
                (action: FetchWorkplacesAction) => {

                    return this.payrollDataService.fetchWorkplaces()
                        .pipe(
                            ossNormalize(WORKPLACE_ENTITY, Workplace, 'workplaces'),
                            mergeMap((normalized: NormalizeResponse) => {
                                const actions: Action[] = [
                                    new SetWorkplacesAction(normalized),
                                    new SetWorkplacesFetchingAction(false)
                                ];
                                return actions;
                            }),
                            ossCatchError(([actions, error]) => from(actions.concat([new SetWorkplacesFetchingAction(false)])))
                        );
                }
            )
        )
    );

    fetchMoreWorkplaces$ = createEffect(() =>
        this.actions$.pipe(
            ofType<FetchMoreWorkplacesAction>(WORKPLACES_FETCH_MORE),
            withLatestFrom(
                this.store$.select(getWorkplaceList)
            ),
            switchMap(([action, workplaceList]) => {
                return this.payrollDataService.fetchWorkplaces(workplaceList.meta.next_cursor)
                .pipe(
                    ossNormalize(WORKPLACE_ENTITY, Workplace, 'workplaces'),
                    mergeMap((normalized: NormalizeResponse) => {

                        return [
                            new MergeWorkplacesAction(normalized),
                            new SetWorkplacesFetchingMoreAction(false)
                        ];
                    }),
                    ossCatchError(([actions, error]) => {
                        return from(actions.concat([new SetWorkplacesFetchingMoreAction(false)]))
                    })
                );
            })
        )
    );
}
